// source: dash/v1/lesson_book.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var dash_v1_models_pb = require('../../dash/v1/models_pb.js');
goog.object.extend(proto, dash_v1_models_pb);
var types_v1_status_pb = require('../../types/v1/status_pb.js');
goog.object.extend(proto, types_v1_status_pb);
goog.exportSymbol('proto.dash.v1.GetLessonBookRequest', null, global);
goog.exportSymbol('proto.dash.v1.GetLessonBookResponse', null, global);
goog.exportSymbol('proto.dash.v1.ListLessonBooksRequest', null, global);
goog.exportSymbol('proto.dash.v1.ListLessonBooksResponse', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonBookRequest', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonBookRequest.ContentCase', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonBookResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.GetLessonBookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.GetLessonBookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.GetLessonBookRequest.displayName = 'proto.dash.v1.GetLessonBookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.GetLessonBookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.GetLessonBookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.GetLessonBookResponse.displayName = 'proto.dash.v1.GetLessonBookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.PutLessonBookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.dash.v1.PutLessonBookRequest.oneofGroups_);
};
goog.inherits(proto.dash.v1.PutLessonBookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.PutLessonBookRequest.displayName = 'proto.dash.v1.PutLessonBookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.PutLessonBookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.PutLessonBookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.PutLessonBookResponse.displayName = 'proto.dash.v1.PutLessonBookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.ListLessonBooksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.ListLessonBooksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.ListLessonBooksRequest.displayName = 'proto.dash.v1.ListLessonBooksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.ListLessonBooksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dash.v1.ListLessonBooksResponse.repeatedFields_, null);
};
goog.inherits(proto.dash.v1.ListLessonBooksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.ListLessonBooksResponse.displayName = 'proto.dash.v1.ListLessonBooksResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.GetLessonBookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.GetLessonBookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.GetLessonBookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonBookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.GetLessonBookRequest}
 */
proto.dash.v1.GetLessonBookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.GetLessonBookRequest;
  return proto.dash.v1.GetLessonBookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.GetLessonBookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.GetLessonBookRequest}
 */
proto.dash.v1.GetLessonBookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.GetLessonBookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.GetLessonBookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.GetLessonBookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonBookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.dash.v1.GetLessonBookRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.GetLessonBookRequest} returns this
 */
proto.dash.v1.GetLessonBookRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.GetLessonBookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.GetLessonBookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.GetLessonBookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonBookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonBook: (f = msg.getLessonBook()) && dash_v1_models_pb.LessonBook.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.GetLessonBookResponse}
 */
proto.dash.v1.GetLessonBookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.GetLessonBookResponse;
  return proto.dash.v1.GetLessonBookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.GetLessonBookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.GetLessonBookResponse}
 */
proto.dash.v1.GetLessonBookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonBook;
      reader.readMessage(value,dash_v1_models_pb.LessonBook.deserializeBinaryFromReader);
      msg.setLessonBook(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.GetLessonBookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.GetLessonBookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.GetLessonBookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonBookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonBook();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonBook.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonBook lesson_book = 1;
 * @return {?proto.dash.v1.LessonBook}
 */
proto.dash.v1.GetLessonBookResponse.prototype.getLessonBook = function() {
  return /** @type{?proto.dash.v1.LessonBook} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonBook, 1));
};


/**
 * @param {?proto.dash.v1.LessonBook|undefined} value
 * @return {!proto.dash.v1.GetLessonBookResponse} returns this
*/
proto.dash.v1.GetLessonBookResponse.prototype.setLessonBook = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.GetLessonBookResponse} returns this
 */
proto.dash.v1.GetLessonBookResponse.prototype.clearLessonBook = function() {
  return this.setLessonBook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.GetLessonBookResponse.prototype.hasLessonBook = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.dash.v1.PutLessonBookRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.dash.v1.PutLessonBookRequest.ContentCase = {
  CONTENT_NOT_SET: 0,
  TARGET_URL: 2,
  FILE: 3
};

/**
 * @return {proto.dash.v1.PutLessonBookRequest.ContentCase}
 */
proto.dash.v1.PutLessonBookRequest.prototype.getContentCase = function() {
  return /** @type {proto.dash.v1.PutLessonBookRequest.ContentCase} */(jspb.Message.computeOneofCase(this, proto.dash.v1.PutLessonBookRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.PutLessonBookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.PutLessonBookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.PutLessonBookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonBookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonBook: (f = msg.getLessonBook()) && dash_v1_models_pb.LessonBook.toObject(includeInstance, f),
    targetUrl: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    file: (f = msg.getFile()) && dash_v1_models_pb.File.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.PutLessonBookRequest}
 */
proto.dash.v1.PutLessonBookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.PutLessonBookRequest;
  return proto.dash.v1.PutLessonBookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.PutLessonBookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.PutLessonBookRequest}
 */
proto.dash.v1.PutLessonBookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonBook;
      reader.readMessage(value,dash_v1_models_pb.LessonBook.deserializeBinaryFromReader);
      msg.setLessonBook(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTargetUrl(value);
      break;
    case 3:
      var value = new dash_v1_models_pb.File;
      reader.readMessage(value,dash_v1_models_pb.File.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.PutLessonBookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.PutLessonBookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.PutLessonBookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonBookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonBook();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonBook.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      dash_v1_models_pb.File.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonBook lesson_book = 1;
 * @return {?proto.dash.v1.LessonBook}
 */
proto.dash.v1.PutLessonBookRequest.prototype.getLessonBook = function() {
  return /** @type{?proto.dash.v1.LessonBook} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonBook, 1));
};


/**
 * @param {?proto.dash.v1.LessonBook|undefined} value
 * @return {!proto.dash.v1.PutLessonBookRequest} returns this
*/
proto.dash.v1.PutLessonBookRequest.prototype.setLessonBook = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonBookRequest} returns this
 */
proto.dash.v1.PutLessonBookRequest.prototype.clearLessonBook = function() {
  return this.setLessonBook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonBookRequest.prototype.hasLessonBook = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool target_url = 2;
 * @return {boolean}
 */
proto.dash.v1.PutLessonBookRequest.prototype.getTargetUrl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dash.v1.PutLessonBookRequest} returns this
 */
proto.dash.v1.PutLessonBookRequest.prototype.setTargetUrl = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.dash.v1.PutLessonBookRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.dash.v1.PutLessonBookRequest} returns this
 */
proto.dash.v1.PutLessonBookRequest.prototype.clearTargetUrl = function() {
  return jspb.Message.setOneofField(this, 2, proto.dash.v1.PutLessonBookRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonBookRequest.prototype.hasTargetUrl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional File file = 3;
 * @return {?proto.dash.v1.File}
 */
proto.dash.v1.PutLessonBookRequest.prototype.getFile = function() {
  return /** @type{?proto.dash.v1.File} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.File, 3));
};


/**
 * @param {?proto.dash.v1.File|undefined} value
 * @return {!proto.dash.v1.PutLessonBookRequest} returns this
*/
proto.dash.v1.PutLessonBookRequest.prototype.setFile = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.dash.v1.PutLessonBookRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonBookRequest} returns this
 */
proto.dash.v1.PutLessonBookRequest.prototype.clearFile = function() {
  return this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonBookRequest.prototype.hasFile = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.PutLessonBookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.PutLessonBookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.PutLessonBookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonBookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonBook: (f = msg.getLessonBook()) && dash_v1_models_pb.LessonBook.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.PutLessonBookResponse}
 */
proto.dash.v1.PutLessonBookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.PutLessonBookResponse;
  return proto.dash.v1.PutLessonBookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.PutLessonBookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.PutLessonBookResponse}
 */
proto.dash.v1.PutLessonBookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonBook;
      reader.readMessage(value,dash_v1_models_pb.LessonBook.deserializeBinaryFromReader);
      msg.setLessonBook(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.PutLessonBookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.PutLessonBookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.PutLessonBookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonBookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonBook();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonBook.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonBook lesson_book = 1;
 * @return {?proto.dash.v1.LessonBook}
 */
proto.dash.v1.PutLessonBookResponse.prototype.getLessonBook = function() {
  return /** @type{?proto.dash.v1.LessonBook} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonBook, 1));
};


/**
 * @param {?proto.dash.v1.LessonBook|undefined} value
 * @return {!proto.dash.v1.PutLessonBookResponse} returns this
*/
proto.dash.v1.PutLessonBookResponse.prototype.setLessonBook = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonBookResponse} returns this
 */
proto.dash.v1.PutLessonBookResponse.prototype.clearLessonBook = function() {
  return this.setLessonBook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonBookResponse.prototype.hasLessonBook = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.ListLessonBooksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.ListLessonBooksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.ListLessonBooksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonBooksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    areaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    lessonId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.ListLessonBooksRequest}
 */
proto.dash.v1.ListLessonBooksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.ListLessonBooksRequest;
  return proto.dash.v1.ListLessonBooksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.ListLessonBooksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.ListLessonBooksRequest}
 */
proto.dash.v1.ListLessonBooksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAreaId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLessonId(value);
      break;
    case 3:
      var value = /** @type {!proto.types.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.ListLessonBooksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.ListLessonBooksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.ListLessonBooksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonBooksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLessonId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 area_id = 1;
 * @return {number}
 */
proto.dash.v1.ListLessonBooksRequest.prototype.getAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.ListLessonBooksRequest} returns this
 */
proto.dash.v1.ListLessonBooksRequest.prototype.setAreaId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lesson_id = 2;
 * @return {number}
 */
proto.dash.v1.ListLessonBooksRequest.prototype.getLessonId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.ListLessonBooksRequest} returns this
 */
proto.dash.v1.ListLessonBooksRequest.prototype.setLessonId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional types.v1.Status status = 3;
 * @return {!proto.types.v1.Status}
 */
proto.dash.v1.ListLessonBooksRequest.prototype.getStatus = function() {
  return /** @type {!proto.types.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.types.v1.Status} value
 * @return {!proto.dash.v1.ListLessonBooksRequest} returns this
 */
proto.dash.v1.ListLessonBooksRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dash.v1.ListLessonBooksResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.ListLessonBooksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.ListLessonBooksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.ListLessonBooksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonBooksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonBooksList: jspb.Message.toObjectList(msg.getLessonBooksList(),
    dash_v1_models_pb.LessonBook.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.ListLessonBooksResponse}
 */
proto.dash.v1.ListLessonBooksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.ListLessonBooksResponse;
  return proto.dash.v1.ListLessonBooksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.ListLessonBooksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.ListLessonBooksResponse}
 */
proto.dash.v1.ListLessonBooksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonBook;
      reader.readMessage(value,dash_v1_models_pb.LessonBook.deserializeBinaryFromReader);
      msg.addLessonBooks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.ListLessonBooksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.ListLessonBooksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.ListLessonBooksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonBooksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonBooksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      dash_v1_models_pb.LessonBook.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LessonBook lesson_books = 1;
 * @return {!Array<!proto.dash.v1.LessonBook>}
 */
proto.dash.v1.ListLessonBooksResponse.prototype.getLessonBooksList = function() {
  return /** @type{!Array<!proto.dash.v1.LessonBook>} */ (
    jspb.Message.getRepeatedWrapperField(this, dash_v1_models_pb.LessonBook, 1));
};


/**
 * @param {!Array<!proto.dash.v1.LessonBook>} value
 * @return {!proto.dash.v1.ListLessonBooksResponse} returns this
*/
proto.dash.v1.ListLessonBooksResponse.prototype.setLessonBooksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.dash.v1.LessonBook=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dash.v1.LessonBook}
 */
proto.dash.v1.ListLessonBooksResponse.prototype.addLessonBooks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dash.v1.LessonBook, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dash.v1.ListLessonBooksResponse} returns this
 */
proto.dash.v1.ListLessonBooksResponse.prototype.clearLessonBooksList = function() {
  return this.setLessonBooksList([]);
};


goog.object.extend(exports, proto.dash.v1);
